import { render } from "./result-box.vue?vue&type=template&id=694a603c"
import script from "./result-box.vue?vue&type=script&lang=js"
export * from "./result-box.vue?vue&type=script&lang=js"

import "./result-box.vue?vue&type=style&index=0&id=694a603c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__